(function () {
  'use strict';

  function closeMobileMenu(link) {
    var menu = link.closest ? link.closest('.mobile-menu') : null;
    if (menu) menu.removeAttribute('open');
  }

  document.querySelectorAll('.mobile-nav a').forEach(function (link) {
    link.addEventListener('click', function () { closeMobileMenu(link); });
  });

  document.addEventListener('shopify:section:load', function (event) {
    var scope = event.target || document;
    scope.querySelectorAll('.mobile-nav a').forEach(function (link) {
      if (link.getAttribute('data-mobile-nav-bound') === 'true') return;
      link.setAttribute('data-mobile-nav-bound', 'true');
      link.addEventListener('click', function () { closeMobileMenu(link); });
    });
  });
})();
